import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import { ThemeProvider } from "@/lib/theme";
import { I18nProvider } from "@/lib/i18n";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Dashboards from "@/pages/Dashboards";
import DashboardDetail from "@/pages/DashboardDetail";
import Datasources from "@/pages/Datasources";
import Alarms from "@/pages/Alarms";
import Companies from "@/pages/Companies";
import Users from "@/pages/Users";
import SmtpSettings from "@/pages/SmtpSettings";
import AuditLogs from "@/pages/AuditLogs";
import ContactMessages from "@/pages/ContactMessages";
import { Toaster } from "sonner";

function App() {
  return (
    <I18nProvider>
      <ThemeProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
                <Route path="/dashboards" element={<Dashboards />} />
                <Route path="/dashboards/:id" element={<DashboardDetail />} />
                <Route path="/datasources" element={<ProtectedRoute adminOnly><Datasources /></ProtectedRoute>} />
                <Route path="/alarms" element={<ProtectedRoute adminOnly><Alarms /></ProtectedRoute>} />
                <Route path="/companies" element={<ProtectedRoute adminOnly><Companies /></ProtectedRoute>} />
                <Route path="/users" element={<ProtectedRoute adminOnly><Users /></ProtectedRoute>} />
                <Route path="/smtp" element={<ProtectedRoute adminOnly><SmtpSettings /></ProtectedRoute>} />
                <Route path="/contact-messages" element={<ProtectedRoute adminOnly><ContactMessages /></ProtectedRoute>} />
                <Route path="/audit" element={<ProtectedRoute adminOnly><AuditLogs /></ProtectedRoute>} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <Toaster position="top-right" richColors closeButton />
          </BrowserRouter>
        </AuthProvider>
      </ThemeProvider>
    </I18nProvider>
  );
}

export default App;
